import { useState, useEffect } from 'react';
import {
  FaFolderOpen,
  FaTasks,
  FaBars,
  FaSignOutAlt,
  FaCheckCircle,
  FaCog ,
  FaUsers,
} from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(true);
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    axios
      .get('/api/login.php?action=dashboard', {
        withCredentials: true,
      })
      .then((res) => setAdmin(res.data.admin))
      .catch(() => (window.location.href = '/login'));
  }, []);

  const handleLogout = () => {
    axios
      .post(
        '/api/login.php?action=logout',
        {},
        { withCredentials: true }
      )
      .then(() => (window.location.href = '/login'))
      .catch((err) => console.error('Logout failed', err));
  };

  const navItems = [
    { icon: <FaFolderOpen />, label: 'Projects', to: '/' },
    { icon: <FaTasks />, label: 'Tasks', to: '/alltask' },
    { icon: <FaCheckCircle />, label: 'Completed Task', to: '/completetask' },
    { icon: <FaUsers  />, label: 'User Stats', to: '/userstats' },
    { icon: <FaCog  />, label: 'Setting', to: '/setting' },

  ];

  return (
    <div
      className={`h-screen ${
        collapsed ? 'w-16' : 'w-58'
      } bg-gray-800 text-white shadow-md transition-all duration-300 z-50  sticky top-0 z-10`}
    >
      {/* Header */}
      <div className="flex items-center justify-between p-4 border-b border-gray-700">
        {!collapsed && <div className="text-base font-bold">AGPH-TMS</div>}
        <button
          className="text-white text-xl focus:outline-none px-2"
          onClick={() => setCollapsed(!collapsed)}
        >
          <FaBars />
        </button>
      </div>

      {/* Welcome */}
      {!collapsed && admin && (
        <div className="text-sm px-4 py-2 border-b border-gray-700">
          Welcome, <span className="font-semibold">{admin.username}</span>
        </div>
      )}

      {/* Navigation */}
      <ul className="mt-6 space-y-2 px-4 relative">
  {navItems.map(({ icon, label, to }) => {
    const isActive = location.pathname === to;
    return (
      <li
        key={label}
        className={`relative group flex items-center ${
          collapsed ? 'justify-center' : 'justify-start'
        } space-x-3 p-3 rounded cursor-pointer transition-colors ${
          isActive
            ? 'bg-gray-700 text-red-400 shadow-md'
            : 'text-gray-300 hover:bg-gray-700 hover:text-white'
        }`}
        onClick={() => navigate(to)}
      >
        <span className={`text-sm ${
          collapsed ? 'pl-3' : ''
        } `}>{icon}</span>

        {!collapsed && (
          <span className="text-sm font-medium">{label}</span>
        )}

        {collapsed && (
          <span className="absolute left-14 top-1/2 -translate-y-1/2 whitespace-nowrap bg-black text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-20 shadow-lg">
            {label}
          </span>
        )}
      </li>
    );
  })}

        {/* Logout */}
        <li
          className="flex items-center space-x-3 p-2 hover:bg-gray-700 rounded cursor-pointer text-gray-300 hover:text-white"
          onClick={handleLogout}
        >
          <FaSignOutAlt />
          {!collapsed && <span className="text-sm font-medium">Logout</span>}
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;
